export default "https://cdn-gra.amplement.io/statics/sounds/outgoingRinging.mp3";